import styled from "styled-components";
import { useTranslation } from "react-i18next";
import routes from "core/Routes";
import { NavLink, useHistory } from "react-router-dom";
import themeProps from "theme/themes";
import LanguageSettings from "components/Settings/LanguageSettings";
import ThemeSettings from "components/Settings/ThemeSettings";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { logout } from "store/slices/userSlice";
import ButtonLink from "components/Button/ButtonLink";
import { resetProjects } from "store/slices/projectsSlice";
import { resetPreferences } from "store/slices/preferencesSlice";
import logo from "assets/logo.svg";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 60px;
  padding: 0 10%;
  box-sizing: border-box;
  box-shadow: 0px 30px 50px rgba(0, 0, 0, 0.1);
`;

const LeftItems = styled.div`
  display: flex;
  align-items: center;
`;

const RightItmes = styled.div`
  display: flex;
  align-items: center;
`;

const Item = styled(NavLink)`
  margin-left: 5rem;
  font-size: 1.5rem;
  color: ${(props: themeProps) => props.theme.text.primary};
  text-decoration: none;
`;

const SignOutButton = styled.button`
  color: ${(props: themeProps) => props.theme.main.primary};
  background-color: transparent;
  border: none;
  outline: none;
  margin-left: 40px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
`;

const Logo = styled.img`
  width: 110px;
`;

const items = [
  {
    label: "profile",
    route: routes.profile.root,
  },
  {
    label: "explore",
    route: routes.explore.root,
  },
  {
    label: "projects",
    route: routes.projects.root,
  },
];

const Navbar = () => {
  const { t } = useTranslation("nav, forms");
  const dispatch = useAppDispatch();
  const history = useHistory();
  const token = useAppSelector((state) => state.user.auth.access_token);

  const handleSignout = (e: any) => {
    e.preventDefault();
    localStorage.removeItem("auth:token");
    dispatch(logout());
    dispatch(resetProjects());
    dispatch(resetPreferences());
    history.push(routes.login);
  };

  return (
    <Wrapper>
      <LeftItems>
        <Logo src={logo} />
        {token &&
          items.map((item) => (
            <Item
              key={item.label}
              to={item.route}
              activeStyle={{ color: "#7D02FA" }}
            >
              {t(`nav:${item.label}`)}
            </Item>
          ))}
      </LeftItems>
      <RightItmes>
        {token && (
          <ButtonLink
            label={t("project:createProject")}
            to={routes.projects.new}
            filled
            styles={{
              padding: "10px 20px",
              marginRight: "20px",
            }}
          />
        )}
        <ThemeSettings />
        <LanguageSettings />
        {token ? (
          <SignOutButton onClick={handleSignout}>
            {t("forms:signout")}
          </SignOutButton>
        ) : (
          <>
            <ButtonLink
              label={t("forms:register")}
              to={routes.register}
              styles={{
                marginLeft: "40px",
                paddingRight: "20px",
                paddingLeft: "20px",
              }}
            />
            <ButtonLink
              label={t("forms:login")}
              to={routes.login}
              filled
              styles={{
                marginLeft: "20px",
                paddingRight: "20px",
                paddingLeft: "20px",
              }}
            />
          </>
        )}
      </RightItmes>
    </Wrapper>
  );
};

export default Navbar;
